import { TeamPlayersNumber } from '../types/team-players-number';

export const getTeamPlayersNumberOptions = (): number[] => Object
  .values(TeamPlayersNumber)
  .filter((num): num is number => typeof num === 'number');
